<template>
  <v-row class="desposite-dashboadpage" >
    <v-col xs="8" md="8">
      <ul class="breadcrumbs-list">
        <a  @click="backButton"><li>Investment</li></a>
        <li>&nbsp;>&nbsp;Bullions Dashboard</li>
      </ul>
      <div class="head-text">
        <h1>Bullions Dashboard</h1>
      </div>

      <BullionsTab />

    </v-col>  
    <v-col xs="4" md="4">
      <div class="right-sidetop-box">
        <div class="select-box">
          <v-card> 
            <v-select
              :items="member_items"
              :v-model="member_name"
              item-value="id"
              item-text="name"
              chips
              label="All Users"
              @change="refreshDashboard($event)"
            ></v-select>
          </v-card>  
        </div>
        <div class="add-btn" v-if="allow_user_activity =='yes'">
          <v-btn class="orange-btn btn" @click="subCategory">
            ADD NEW
          </v-btn>
        </div>  
      </div>
      <v-row v-if="show_graph_block">
        <v-col cols="12" sm="12">
          <v-card class="right-sidebox">
            <div cols="12" class="total-deposit-box" >
              <span>
                Total Bullion Valuation {{currentDate | moment("DD MMM, Y")}}
              </span> 
              <p>
                <span>  &#8377;</span>
                {{total.toLocaleString()}}
              </p> 
            </div>
            <div id="chart">
              <!-- <apexchart type="donut" :options="chartOptions" :series="series"></apexchart> -->
              <apexchart type="pie" :options="chartOptions" :series="series" graphData></apexchart>
              <ul class="chart-listbox">
                <li class="first-li">
                   <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #FFC241"></span>
                    <p>Bars & Coins</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{bars_total_details}}</span>
                </li>
                 <li class="second-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #0F487F"></span>
                    <p>Jewellery</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{jewellery_total_details}}</span>
                </li>
                 <li class="third-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #3D8AF7"></span>
                    <p>Digital Gold</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{digital_gold_total_details}}</span>
                </li> 
                <li class="forth-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #FFC241"></span>
                    <p>Gold Bonds</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{gold_bonds_total_details}}</span>
                </li>
              </ul>
            </div>

            <div class="button-box">
              <v-btn class="btn download-btn" @click="downloadReport">
                <v-img
                max-height="20"
                max-width="16"
                :src="require('@/assets/images/download-icon.png')"
              >
              </v-img>
                DOWNLOAD
              </v-btn>
              <!-- <v-btn class="btn share-btn">
                 <v-img
                    max-height="20"
                    max-width="18"
                    :src="require('@/assets/images/share-icon.png')"
                  >
                </v-img>
                SHARE
              </v-btn> -->
              <v-menu
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="btn share-btn" v-bind="attrs" v-on="on">
                     <v-img
                        max-height="20"
                        max-width="18"
                        :src="require('@/assets/images/share-icon.png')"
                      >
                    </v-img>
                    SHARE
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <WhatsApp :url="share_report_url" scale="1.6"></WhatsApp>
                    </v-list-item-title>
                    <v-list-item-title>
                      <Telegram :url="share_report_url" scale="1.6"></Telegram>
                    </v-list-item-title>
                    <v-list-item-title>
                      <Email :url="share_report_url" scale="1.6"></Email>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

          </v-card> 
        </v-col> 
      </v-row>
       <!-- <div v-if="!show_graph_block">
              <span>No data is available for choosen parameters.</span>
      </div>  --> 
    </v-col>  
  </v-row>  
</template>
<script>
  import BullionsTab from './BullionsTab.vue';
  import { GET_BULLIONS_DATA, UPDATE_USER_DETAILS } from "../../store/actions.type";
  import { isEmpty } from 'lodash';
  import { WhatsApp, Telegram, Email } from 'vue-socialmedia-share';
  import axios from "axios";
  import JwtService from "../.././common/jwt.service";
  export default {
    components: {
        BullionsTab,
        WhatsApp,
        Telegram,
        Email,
    },
    data: () => ({
      member_items: [],
      member_name:'',
      three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
      edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
      delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
      currentDate: new Date().setDate(new Date().getDate()),
      series: [0,0,0,0],
      chartOptions: {
         dataLabels: {
            formatter(val) {
              return [ val.toFixed() + '%']
            }
          },
        labels: ["Bars & Coins Details", "Jewellery Details", "Digital Gold Details","Sovereign Gold Bonds Details"],
        colors: ['#FFC241', '#0F487F', '#3D8AF7','#D757F6'],
        chart: {
          type: 'pie',
          edrawOnParentResize: true,
        },
        responsive: [{
          breakpoint: undefined,
          options: {
          }
        }],
        legend: {
          position: 'bottom',
          customLegendItems: ['','','','',''],
           markers: {
          width: 0,
          height: 0,
          strokeWidth: 0,
          strokeColor: '',
          fillColors: undefined,
          radius: 0,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
      },
        }
      },
      total:'', 
      saving_balance:'',
      reccuring_balance:'',
      deposite_balance:'',
      sukanaya_balance:'',
      tabName:'',
      show_graph_block:true,
      memberId:'',
      bars_coins_detail:[],
      digital_gold_detail:[],
      gold_bonds_detail:[],
      jewellery_detail:[],
      bars_total_details:0,
      digital_gold_total_details:0,
      gold_bonds_total_details:0,
      jewellery_total_details:0, 
      share_report_url:'',
      allow_user_activity:localStorage.getItem('allow_user_activity')
    }), 
    mounted (){
      this.refreshDashboard('');
      Fire.$on("barsAndCoinsGraphData", () => {
        this.graphData();
        this.shareLink();
      });

      // let current_category_data = { 
      //       current_category_id: 7,
      //     };

      // this.updateCurrentCategoryIdData('commitCurrentCategoryIdData', current_category_data);

      if(!isEmpty(this.$store.getters.getBullionsData)) {
        this.graphData();
        this.shareLink();
      }

      },
    methods:{
      subCategory(){
        this.$router.push({ name: "SubCategory" , params: { current_category_id : 7 } }).catch(()=>{});
      },
      backButton(){
        this.$router.push({ name: 'Investment'}).catch(()=>{});
      },
      graphData(){
      
        this.series = this.series.length == 0 ? this.series : [];
        
        this.bars_coins_detail = this.$store.getters.getBullionsData.data.bars_coins_detail['description'];
        this.digital_gold_detail = this.$store.getters.getBullionsData.data.digital_gold_detail['description'];
        this.gold_bonds_detail = this.$store.getters.getBullionsData.data.gold_bonds_detail['description'];
        this.jewellery_detail = this.$store.getters.getBullionsData.data.jewellery_detail['description'];
        
        this.member_items = [];
        this.$store.getters.getBullionsData.member_list.forEach(elementData => {
          
          this.member_items.push({'id':elementData.id,'name':elementData.name})

        });
        this.total =this.$store.getters.getBullionsData.balaces_details.total;
        this.$store.getters.getBullionsData.balaces_details.balances.forEach(balance_detail => {
          this.series.push(parseFloat(balance_detail.balance));
        });
        if (this.total == 0) {
          this.show_graph_block = false;
        }else{
          this.show_graph_block = true;
        }

        this.bars_total_details = this.series[0];
        this.digital_gold_total_details = this.series[2];
        this.gold_bonds_total_details = this.series[3];
        this.jewellery_total_details = this.series[1];
         
      },
      refreshDashboard(event){
        this.$loading(true);
        this.memberId = event;

        // this.singleUpdateAuthUser('commitSingleData', {key:'selected_value', value:event.toString()});
        let userData = [
          {key:'selected_value', value:event.toString()},
        ]
        this.$store.dispatch(UPDATE_USER_DETAILS,userData)
        let user_name =  this.$store.getters.getUserDetails.user_name;
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        this.$store
        .dispatch(GET_BULLIONS_DATA, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            member_id:event,
          },
          api: "get-bullion-form-detail",
        })
        .then(() => {

           Fire.$emit('barsAndCoinsGraphData');

           this.$loading(false);
         
        }).catch(() => {
          this.$loading(false);
        });
      },
      deleteMutualFunds(id){
        swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
          denyButtonText: `NO`
        })
        .then(result => {
          
          if (result.isConfirmed) {
          
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let user_name =  this.$store.getters.getUserDetails.user_name;

          this.$store
            .dispatch(POST_API, {
              data: {
                aws_cognito_id: cognito_idp,
                form_id:id,
              },
              api: "delete-form",
            })
            .then(() => {
               this.graphData();
              Toast.fire({
                        icon: 'success',
                        title: 'Data deleted successfully.'
                  })
            });

          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
      },
      editBarsAndCoins(editId,form_type){
        
       return form_type == 25 ? this.$router.push({ name: "edit-bars-coins", params: { editId:editId}}): form_type == 27 ? this.$router.push({ name: "edit-digital-gold", params: { editId:editId}}) : form_type == 34 ? this.$router.push({ name: "edit-gold-bonds", params: { editId:editId}}) : form_type == 26 ? this.$router.push({ name: "edit-jewellery", params: { editId:editId}}) : '';
      },

      downloadReport(){
        window.open(this.$store.getters.getBullionsData.pdf_url, '_blank');
      },
      shareLink(){
        this.share_report_url = this.$store.getters.getBullionsData.pdf_url;
        return this.share_report_url;
      },

    } 
  }
</script>